import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import App from './App';
import CONF from './Conf';
import registerServiceWorker from './registerServiceWorker';

import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';

/*
  Apollo uses heuristics by default to determine which interface or union a
  fragment represents. If two different types have the same fields then the
  heuristic cannot tell them apart but it will guess anyway. This bootstrapper
  uses graphql introspection and IntrospectionFragmentMatcher to force apollo to
  do the right thing instead of guessing.
*/
function bootstrapApollo(callback, error) {
  fetch(CONF.service.insights.uri, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query: `
				{
				__schema {
					types {
					kind
					name
					possibleTypes {
						name
					}
					}
				}
				}
			`,
    }),
  })
    .then((result) => result.json())
    .then((result) => {
      callback({
        graphqlClient: new ApolloClient({
          link: ApolloLink.from([
            onError(({ graphQLErrors, networkError }) => {
              if (graphQLErrors) console.error(`[GraphQL errors]`, graphQLErrors);
              if (networkError) console.error(`[Network error]`, networkError);
            }),
            new HttpLink({
              uri: CONF.service.insights.uri,
              credentials: CONF.service.insights.credentials,
            }),
          ]),
          cache: new InMemoryCache({
            fragmentMatcher: new IntrospectionFragmentMatcher({
              introspectionQueryResultData: result.data,
            }),
          }),
        }),
      });
    })
    .catch((err) => error(err));
}

bootstrapApollo(
  function ({ graphqlClient }) {
    ReactDOM.render(<App graphqlClient={graphqlClient} />, document.getElementById('root'));
    registerServiceWorker();
  },
  function (err) {
    ReactDOM.render(<App />, document.getElementById('root'));
  }
);
